import { useMemo } from "react";
import { Particles } from "@tsparticles/react";

export default function ParticleField() {
  const options = useMemo(
    () => ({
      fullScreen: { enable: false },
      background: { color: "transparent" },
      fpsLimit: 60,
      particles: {
        number: { value: 46, density: { enable: true, area: 900 } },
        color: { value: ["#7C93FF", "#3652FF", "#ffffff"] },
        opacity: { value: { min: 0.15, max: 0.5 } },
        size: { value: { min: 1, max: 2.5 } },
        links: {
          enable: true,
          distance: 120,
          color: "#3652FF",
          opacity: 0.15,
          width: 1,
        },
        move: {
          enable: true,
          speed: 0.5,
          direction: "none",
          outModes: { default: "out" },
        },
      },
      interactivity: {
        events: {
          onHover: { enable: true, mode: "grab" },
        },
        modes: {
          grab: { distance: 150, links: { opacity: 0.4 } },
        },
      },
      detectRetina: true,
    }),
    [],
  );

  return (
    <Particles
      id="ksas-particle-field"
      options={options}
      className="absolute inset-0"
    />
  );
}